"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const bindEvents = ({ onFocusOrActive, onBlurOrBackground, onStoreUpdated, }) => {
    if (onStoreUpdated) {
        window.addEventListener('storage', ({ key }) => {
            if (key === constants_1.STORAGE_KEY) {
                onStoreUpdated();
            }
        });
    }
    window.addEventListener('blur', onBlurOrBackground);
    window.addEventListener('focus', onFocusOrActive);
};
exports.default = bindEvents;
//# sourceMappingURL=bindEvents.js.map